import React from "react";
import styled from "styled-components";
import { globalTheme } from "@clds/component-theme";
import t from "common/i18n";
import { useFilterParams, useSearchParams, useUI } from "../../selectors";
import { POPULAR_CATEGORIES, COLOR_OPTIONS, COLOR_TYPE_BLACK_AND_WHITE, EDITORIAL_SLUG } from "../../data/consts";
import BlackAndWhiteIcon from "~/assets/images/black_and_white.svg";

export const SummaryBox = styled.div`
	padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.sm};
	border-bottom: 1px solid ${globalTheme.palette.secondary};
	font-weight: bold;
	display: flex;
	flex-wrap: wrap;
`;


const ElementBox = styled.div`
	display: flex;
	padding-right: ${globalTheme.spacing.xxs}
`;
const ColorFilterBox = styled.div`
	display: flex;
`;
export const ColorBox = styled.div`
	width: 12px;
	height: 12px;
	border-radius: ${globalTheme.radius.md};
	background: ${({ color }) => color};
	border: 1px solid ${globalTheme.palette.secondary};
	position: relative;
	top: 1px;
	left: 3px;
	img {
		position: absolute;
	}
`;


export default () => {
	const { orientation, color, colorType } = useFilterParams();
	const { searchPhrase, slug } = useSearchParams();
	const { areFiltersSet } = useUI();

	const filtersList = [];
	if (searchPhrase) {
		filtersList.push(`[${searchPhrase}]`);
	}
	if (slug) {
		const category = POPULAR_CATEGORIES.find((item) => item.slug === slug);
		if (category) {
			filtersList.push(t("unsplash.filters.filters_in") + ` ${category.name}`);
		}
	}
	if (orientation && areFiltersSet && slug !== EDITORIAL_SLUG) {
		filtersList.push(t(`unsplash.filters.orientation.${orientation}`));
	}
	if (color && areFiltersSet && searchPhrase) {
		const selectedColor = COLOR_OPTIONS.find((item) => item.value === color);

		selectedColor && filtersList.push(
			<ColorFilterBox>
				{t("unsplash.filters.summary.color", { color: selectedColor.hex })}
				<ColorBox color={selectedColor.hex} />
			</ColorFilterBox>
		);
	}

	if (colorType === COLOR_TYPE_BLACK_AND_WHITE && areFiltersSet && searchPhrase) {
		filtersList.push(
			<ColorFilterBox>
				{t("unsplash.filters.summary.color")}{t(`unsplash.filters.color_types.${COLOR_TYPE_BLACK_AND_WHITE}`)}
				<ColorBox><img src={BlackAndWhiteIcon} /></ColorBox>
			</ColorFilterBox>
		);
	}

	return <>{(searchPhrase || areFiltersSet || slug) &&
		<SummaryBox data-test="filters-summary">
			<ElementBox>
				{t("unsplash.filters.summary.label")}:
			</ElementBox>
			{filtersList.map((item, i) => (
				<ElementBox key={i}>
					{item}
					{i >= 0 && i < filtersList.length - 1 ? "," : null}
				</ElementBox>
			))}
		</SummaryBox>
	}</>;
};
